import React, { useContext, useEffect, useState } from "react";
import "../assets/css/MisCursos.css";
import CCmenu from "../components/CCmenu";
import Contexto from "../context/Contexto";
import MiCurso from "../components/MiCurso";
import PresetComprado from "../components/PresetComprado";
import PH from "../assets/statics/programashibridos.png";
const MisCursos = () => {
  const { cliente, cursoscomprados } = useContext(Contexto);
  const [tusCursos, setTusCursos] = useState([]);
  const [tusProgramas, setTusProgramas] = useState([]);

  const ConstruyeMisCursos = () => {
    console.log("cursoscomprados:", cursoscomprados);
    let claves = Object.keys(cursoscomprados);
    let resultado = [];
    let programas = [];
    for (let i = 0; i < claves.length; i++) {
      if (cursoscomprados[claves[i]].info) {
        if (!cursoscomprados[claves[i]].info.esPrograma) {
          resultado.push(cursoscomprados[claves[i]]);
        } else {
          programas.push(cursoscomprados[claves[i]]);
        }
      }
    }
    resultado.sort((a, b) => {
      if (a.info.ordenFront > b.info.ordenFront) {
        return 1;
      }
      if (a.info.ordenFront < b.info.ordenFront) {
        return -1;
      }

      return 0;
    });
    setTusProgramas(programas);
    setTusCursos(resultado);
  };

  useEffect(() => {
    ConstruyeMisCursos();
    console.log(tusCursos, "tus cursos locos");
  }, [cliente]);
  return (
    <>
      {cliente && tusCursos && (
        <>
          <div className="contenedorMisCursos">
            <CCmenu />
            {tusCursos.length > 1 && (
              <h1 className="titular">TUS PROGRAMAS COMPRADOS</h1>
            )}
            <br /> <br />
            {tusCursos &&
              tusCursos.map((item, i) => {
                if (item.info.modal === "co") {
                  return (
                    <MiCurso
                      key={`${i}CO`}
                      {...item}
                      totales={cliente.progreso}
                      examen={cliente.examenes}
                    ></MiCurso>
                  );
                }
                if (item.info.modal === "co") {
                  return (
                    <MiCurso
                      key={`${i}CO2`}
                      {...item}
                      totales={cliente.progreso}
                      examen={cliente.examenes}
                    ></MiCurso>
                  );
                }
                if (item.info.modal === "prex") {
                  return (
                    <PresetComprado
                      key={item.info.nombre}
                      {...item.info}
                    ></PresetComprado>
                  );
                }
              })}
          </div>
          <br />
          {tusProgramas.length > 0 && (
            <>
              <img src={PH} className="tituloH" />
              <div className="programas">
                {tusProgramas.map((item, i) => (
                  <MiCurso
                    key={`${i}programas`}
                    {...item}
                    totales={cliente.progreso}
                    examen={cliente.examenes}
                  ></MiCurso>
                ))}
              </div>
            </>
          )}
        </>
      )}
    </>
  );
};

export default MisCursos;
